import { render, staticRenderFns } from "./SourceReportTable.vue?vue&type=template&id=b55e263e&"
import script from "./SourceReportTable.vue?vue&type=script&lang=js&"
export * from "./SourceReportTable.vue?vue&type=script&lang=js&"
import style0 from "./SourceReportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
